import React, { useState } from 'react';

const SEVERITY_STYLES = {
  info:    'border-blue-200 bg-blue-50 dark:border-blue-900 dark:bg-blue-950/40 text-blue-900 dark:text-blue-100',
  good:    'border-emerald-200 bg-emerald-50 dark:border-emerald-900 dark:bg-emerald-950/40 text-emerald-900 dark:text-emerald-100',
  warning: 'border-amber-200 bg-amber-50 dark:border-amber-900 dark:bg-amber-950/40 text-amber-900 dark:text-amber-100',
  danger:  'border-red-200 bg-red-50 dark:border-red-900 dark:bg-red-950/40 text-red-900 dark:text-red-100',
};

function substitute(template, vars) {
  if (!template) return '';
  if (!vars) return template;
  return Object.entries(vars).reduce(
    (acc, [k, v]) => acc.replace(new RegExp(`\\{${k}\\}`, 'g'), v == null ? '—' : String(v)),
    template,
  );
}

export default function InsightCard({ title, body, template, vars, severity = 'info', className = '', dismissible = true }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  const renderedTitle = substitute(title, vars);
  const renderedBody = substitute(body || template, vars);
  const styles = SEVERITY_STYLES[severity] || SEVERITY_STYLES.info;
  return (
    <div className={`relative rounded-xl border p-4 text-sm ${styles} ${className}`}>
      {dismissible && (
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          className="absolute top-2 right-2 opacity-60 hover:opacity-100 text-sm leading-none p-1"
        >
          ✕
        </button>
      )}
      {renderedTitle && <div className={`font-semibold mb-1 ${dismissible ? 'pr-6' : ''}`}>{renderedTitle}</div>}
      {renderedBody && <div className={`leading-relaxed ${dismissible && !renderedTitle ? 'pr-6' : ''}`}>{renderedBody}</div>}
    </div>
  );
}
